import { render, staticRenderFns } from "./Three.vue?vue&type=template&id=58817351&scoped=true&"
import script from "./Three.vue?vue&type=script&lang=js&"
export * from "./Three.vue?vue&type=script&lang=js&"
import style0 from "./Three.vue?vue&type=style&index=0&id=58817351&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58817351",
  null
  
)

component.options.__file = "Three.vue"
export default component.exports